export default {
	'delete-journal': 'حذف يومية',
	'view-the-associated-invoice': 'عرض الفاتورة المرتبطة',
	'there-are-no-details': 'لا يوجد تفاصيل',
	'new-journal': 'يومية جديدة'
}